<template>
  <div class="match-pair-select-content animate__slideInUp animate__animated animate__faster">
    <div class="scroll">
      <div class="text-right close-icon" @click="closePopup()">
        <i class="fas fa-times" />
      </div>
      <div class="index" :style="{'background-color': selectedOption.color}">
        {{ selectedOption.index }}
      </div>
      <div class="audience-flex option-title vertical layout center">
        <div v-if="selectedOption.image" class="audience-flex vertical layout center">
          <img class="pair-img" :src="selectedOption.image">
        </div>
        <div v-if="selectedOption.title">
          {{ selectedOption.title }}
        </div>
      </div>
      <div class="match-pair-select-title">
        <div
          v-for="(item, index) in matchPairsOption"
          class="pair-title-item horizontal layout center"
          :key="index"
          @click="selectPair(item, index)"
          :class="{
            'disabled': slide.quizStatus == QuizStatuses.RESULT_SCREEN || isFormSubmitted,
            'correct': slide.quizStatus == QuizStatuses.RESULT_SCREEN && selectedOption.status &&
              selectedOption.status === 'correct',
            'incorrect': slide.quizStatus == 5 && selectedOption.status &&
              selectedOption.status === 'incorrect',
            'selected': (selectedOption.pairSelected && selectedOption.pairSelected.id === item.id),
          }"
        >
          <AhaRadio
            v-if="slide.quizStatus != QuizStatuses.RESULT_SCREEN"
            size="lg"
            class="custom-mr-2"
            :checked="selectPairItem == item.id"
          />

          <span v-if="slide.quizStatus != QuizStatuses.RESULT_SCREEN">
            <AhaKey class="bold" :index="index + 1" />.
          </span>

          <AhaSvg
            v-if="slide.quizStatus == QuizStatuses.RESULT_SCREEN && selectedOption.id === item.id"
            name="correct"
            view-box="0 0 18 18"
            maintain-color
            class="aha-option__icon icon-correct"
          />
          <AhaSvg
            v-if="slide.quizStatus == QuizStatuses.RESULT_SCREEN && selectedOption.id !== item.id"
            name="incorrect"
            view-box="0 0 18 18"
            maintain-color
            class="aha-option__icon icon-incorrect"
          />
          <div class="audience-flex pair-title-text">
            <div v-if="item.pairImage">
              <img :src="item.pairImage" style="width: 150px; border-radius: 4px;">
            </div>
            {{ item.pairTitle }}
          </div>

          <div class="match-pair-selected" v-if="item.pairIndex && slide.quizStatus != QuizStatuses.RESULT_SCREEN">
            {{ item.pairIndex }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import QuizStatuses from '@/constants/QuizStatuses'
import AhaRadio from '../common/Radio.vue'
import AhaKey from '../common/Key.vue'

export default {
  components: {
    AhaRadio,
    AhaKey,
  },
  props: {
    selectedOption: {
      type: Object,
      default: () => {},
    },
    matchPairsOption: {
      type: Array,
      default: () => [],
    },
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectPairItem: null,
      QuizStatuses,
    }
  },
  computed: {
    ...mapState({
      slideOptions: (_, getters) => getters.activeActivity.SlideOptions,
    }),
    ...mapGetters({ slide: 'activeActivity' }),
  },
  methods: {
    selectPair(item, indexPair) {
      if (this.slide.quizStatus == 5 || this.isFormSubmitted) return
      this.selectPairItem = item.id
      const index = this.slideOptions.findIndex((option) => {
        return option.id === this.selectedOption.id
      })
      this.slide.SlideOptions.forEach((option) => {
        if (option.pairSelected && option.pairSelected.id === this.selectPairItem) {
          option.pairSelected = null
        }
      })
      this.slide.SlideOptions[index].pairSelected = {
        id: item.id,
        pairTitle: item.pairTitle,
        pairImage: item.pairImageCropped,
        index: indexPair + 1,
      }
      this.closePopup()
      this.$store.dispatch('updateSlide', this.slide)
    },
    closePopup() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.close-icon {
  position: absolute;
  top: -28px;
  right: 0px;
  cursor: pointer;
  padding: 6px 10px 5px;
  z-index: 100;
  color: #fff;
  background-color: #000;
  border-radius: 25px;
  font-size: 10px;
  text-transform: uppercase;
}
.match-pair-select-content {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-width: 600px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  padding-bottom: 0;
  line-height: 1.4;
  color: #333333;
  text-align: left;

  .scroll {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
}

.index {
  width: 28px;
  height: 28px;
  border-radius: 28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.pair-title-item {
  border: 1px solid #D3D7E1;
  border-radius: 4px;
  margin: 8px 0;
  padding: 10px;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  &.incorrect.selected {
    border: 2px solid #FF4954;
    background-color: rgba(255, 73, 84, 0.5);
  }
  &.correct.selected {
    border: 2px solid #33C173;
    background-color: rgba(51, 193, 115, 0.4);
  }
  &.disabled {
    cursor: not-allowed;
  }

  &.has-img {
    display: block;
    position: relative;

    & .aha-radio {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

  }
}

.pair-img {
  width: 50%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 4px;
}
.pair-title-text {
  padding-left: 10px;
}
.option-title {
  margin-top: 8px;
  margin-bottom: 16px;
  align-items: center;
}
.match-pair-selected {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 18px;
  background-color: #EFF1F7;
  font-size: 14px;
  line-height: 24px;
}
</style>
